import React from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import {getData} from '../../../services/index';
import { Modal, Button,Select } from 'antd';
import { Redirect } from "react-router-dom";
import { Drawer,Menu  } from 'antd';
import 'remixicon/fonts/remixicon.css'
import { MailOutlined, AppstoreOutlined,PhoneFilled, SettingOutlined,UserOutlined,BellOutlined,LockOutlined,LogoutOutlined } from '@ant-design/icons';

import notification_fill from '../../../assets/images/icon/notification_fill.png';
import user from '../../../assets/images/icon/user.png';

import {
	Nav,

	Navbar,
	NavbarBrand,
	Collapse,
	UncontrolledDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	UncontrolledCarousel,
	Progress,
	ListGroup,
	ListGroupItem,
	Row,
	Col,
	Form,
	FormGroup,
	Input,
	Label
} from 'reactstrap';
import $ from 'jquery';

import dark_logo from '../../../assets/images/logo/logo.png';
import logo from '../../../assets/images/icon/logo.png';
import kcis_logo from '../../../assets/images/icon/logo.png';
import user_img from '../../../assets/images/icon/person.png';

const { SubMenu } = Menu;

const mapStateToProps = state => ({
	...state
});

class Header extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: false,
			main_link: '',
			dayplan_link: '',
			aToken: '',
			main_menu: '',
			sub_menu: '',
		}
		this.logout = this.logout.bind(this);
	}

   logout(){
		localStorage.setItem("schoolData",'');
		localStorage.clear();
		window.location.href = '/login/';
	}
	
	change_school(event){
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = event;
        this.setState({school_id: school_id});
		var app = {
			school_id : school_id,
			user_id : user_id
		}
		getData('auth/school_change',app).then((result) => {
			if(result.status==200){
				let responseJson = result;
				if(responseJson.data){
					localStorage.setItem('schoolData',JSON.stringify(responseJson));
					var name = result['data'][0]['user_name'];
					var phone = result['data'][0]['phone'];
					var email = result['data'][0]['email'];
					var user_id = result['data'][0]['user_id'];
					var school_id = result['data'][0]['school_id'];
					var short_name = result['data'][0]['short_name'];
					var type = result['data'][0]['type'];
					var permission = result['data'][0]['permission'];
					this.setState({
						'name': name,
						'phone': phone,
						'email': email,
						'user_id': user_id,
						'school_id': school_id,
						'short_name': short_name,
						'type': type,
						'permission': permission,
					});
					var uri = window.location.toString();
					if (uri.indexOf("?") > 0) {
						var clean_uri = uri.substring(0, uri.indexOf("?"));
						window.history.replaceState({}, document.title, clean_uri);
						window.location.reload(false);
					}
				}
			}
		})
     }
	

	componentDidMount() {
		if(localStorage.getItem("schoolData")){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var url=window.location.pathname.split('/');
			this.setState({ 
				main_menu : url[1],
				sub_menu : url[2]
			});
			
			if(url[1] == 'fees-report'){
				setTimeout(() => {
						this.showMenu('31');
				}, 500);
				
			}
			
			
			var user_id = storedArray['data'][0]['user_id'];
			var permission = storedArray['data'][0]['permission'];
			var staff_designation = storedArray['data'][0]['staff_designation'];
			var type = storedArray['data'][0]['type'];
			var school_id = storedArray['data'][0]['school_id'];
			this.setState({ type: type,school_id:school_id,permission:permission,user_id:user_id,staff_designation:staff_designation });
			
			
			
			if(type == 'admin'){
				const queryParams = new URLSearchParams(window.location.search);
				var new_school_id = queryParams.get('s');
				
				if(new_school_id != '' && new_school_id != null ){
					setTimeout(() => {
						this.change_school(new_school_id);
					}, 500);
				}
			}
			
			var app = {user_id : user_id,school_id:school_id}
			getData('auth/get_login_token',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						var aToken= result['data'];
						localStorage.setItem("aToken",aToken);
						var main_link = 'https://erp.kidzonia.co.in/panel/admin';
						var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
						this.setState({
							main_link: main_link,
							dayplan_link: dayplan_link,
							aToken:aToken
						});
					}
					else{
						var aToken='null';
						localStorage.setItem("aToken",aToken);
						var main_link = 'https://erp.kidzonia.co.in/panel/admin';
						var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
						this.setState({
							main_link: main_link,
							dayplan_link: dayplan_link,
							aToken:aToken
						});
					}
				}
			});
			
		}
	}
    
	showMenu = (id) => {
		var nav_bar = document.getElementById("nav_bar_"+id);
		var short_nav_bar = document.getElementById("short_nav_bar_"+id);
		
		if(nav_bar.classList.contains('active') == true){
			nav_bar.classList.remove("active");
			short_nav_bar.classList.remove("in");
		}else{
			nav_bar.classList.add("active");
			short_nav_bar.classList.add("in");
		}
	}

	render() {
		const {aToken}=this.state;
		const {school_id} = this.state;
		if(localStorage.getItem('schoolData')) {
			return (
				<>
					
				</>
			)
		}
		else{
			return (
				<>

				</>
			)
		}
	}
}
export default connect(mapStateToProps)(Header);
